var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ComponentIds, OutlinedComponent, StlSystemIds, } from "@inter-ikea-core/core";
import { SystemBase2 } from "../systembase/SystemBase2";
import { SimpleOutlineAssemblySystem } from "./SimpleOutlineAssemblySystem";
import { SimpleOutlineBlockingSystem } from "./SimpleOutlineBlockingSystem";
import { SimpleOutlineModelSystem } from "./SimpleOutlineModelSystem";
/**
 * This system handles user interactions, catching changes to outlineable and selected components,
 * marking the entity as outlined whit it is selected.
 *
 * If you want the children or assembly parts to be outlined as well, you can use the
 * {@link SimpleOutlineChildrenSystem} and {@link SimpleOutlineAssemblySystem} respectively.
 * (Or just start everything from {@link OutlineUtils.enableOutlineSystem}.)
 */
var SimpleOutlineSelectedSystem = /** @class */ (function (_super) {
    __extends(SimpleOutlineSelectedSystem, _super);
    function SimpleOutlineSelectedSystem() {
        var _this = _super.call(this, ComponentIds.SELECTED_COMPONENT_ID, ComponentIds.OUTLINEABLE_COMPONENT_ID) || this;
        _this.id = SimpleOutlineSelectedSystem.systemID;
        _this.doingChangesOnComponent = [];
        _this.systemsAfterMe = [
            SimpleOutlineModelSystem.systemID,
            SimpleOutlineAssemblySystem.systemID,
        ];
        _this.systemsBeforeMe = [
            SimpleOutlineBlockingSystem.systemID,
            StlSystemIds.STANDARD_SELECTION_SYSTEM_SYSTEM_ID,
        ];
        return _this;
    }
    SimpleOutlineSelectedSystem.prototype.onAddComponent = function (entity, _newComponent) {
        this.addOutlinedIfOutlineable(entity);
    };
    SimpleOutlineSelectedSystem.prototype.onAddComponent2 = function (entity, _newComponent) {
        this.addOutlinedIfSelected(entity);
    };
    SimpleOutlineSelectedSystem.prototype.onRemoveComponent = function (entity, _oldComponent) {
        entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
    };
    SimpleOutlineSelectedSystem.prototype.onRemoveComponent2 = function (entity, _oldComponent) {
        entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
    };
    SimpleOutlineSelectedSystem.prototype.onUpdateComponent = function (_entity, _oldComponent, _newComponent) {
        // Do nothing
    };
    SimpleOutlineSelectedSystem.prototype.onUpdateComponent2 = function (_entity, _oldComponent, _newComponent) {
        // Do nothing
    };
    SimpleOutlineSelectedSystem.prototype.addOutlinedIfOutlineable = function (entity) {
        if (SimpleOutlineSelectedSystem.isOutlineable(entity)) {
            entity.addComponent(new OutlinedComponent());
        }
    };
    SimpleOutlineSelectedSystem.prototype.addOutlinedIfSelected = function (entity) {
        if (SimpleOutlineSelectedSystem.isSelected(entity)) {
            entity.addComponent(new OutlinedComponent());
        }
    };
    SimpleOutlineSelectedSystem.isOutlineable = function (entity) {
        return entity.hasComponent(ComponentIds.OUTLINEABLE_COMPONENT_ID);
    };
    SimpleOutlineSelectedSystem.isSelected = function (entity) {
        return entity.hasComponent(ComponentIds.SELECTED_COMPONENT_ID);
    };
    SimpleOutlineSelectedSystem.systemID = "SimpleOutlineSelectedSystem";
    return SimpleOutlineSelectedSystem;
}(SystemBase2));
export { SimpleOutlineSelectedSystem };
//# sourceMappingURL=SimpleOutlineSelectedSystem.js.map